export const GET_ALL_PLANT = `
  query GetAllPlant($input: TplantWhereInput, $skip: Float, $take: Float) {
    getPlant(where: $input, skip: $skip, take: $take, orderBy:{createDate: DESC}) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        name
      companyName
      companyId
      province
      district
      }
    }
  }
`;
